import type { ReactNode } from 'react';

/** Ported from src/components/ui/Screen.tsx. */
export default function Screen({ children, title, padded = true, scroll = true }: {
  children: ReactNode;
  title?: string;
  padded?: boolean;
  scroll?: boolean;
}) {
  return (
    <section className={`screen ${padded ? 'screen-padded' : ''} ${scroll ? '' : 'screen-fixed'}`.trim()}>
      {title && <h1 className="type-display screen-title">{title}</h1>}
      {children}
    </section>
  );
}
